import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { publicIdSchema } from "./public-id";

export const accountProfileSchema = z.strictObject({
  firstName: z.string().trim().min(1).max(100).optional(),
  lastName: z.string().trim().max(100).optional(),
  occupationId: z.number().int().positive().max(4294967295).optional(),
});
export const passwordRegistrationSchema = accountProfileSchema.extend({
  email: z.email().trim().max(254).toLowerCase(),
  password: z.string().min(6).max(4096),
  firstName: z.string().trim().min(1).max(100),
  lastName: z.string().trim().max(100),
  turnstileToken: z.string().min(1).max(2048),
});
export const provisionedAccountSchema = z.object({
  public_id: publicIdSchema,
  created: z.boolean(),
});
const endpoint = oc.errors({
  BAD_REQUEST: { message: "Invalid registration" },
  UNAUTHORIZED: { message: "Authentication required" },
  FORBIDDEN: { message: "Sign-in method is not eligible" },
  CONFLICT: { message: "Account requires reconciliation" },
  METHOD_NOT_ALLOWED: { message: "Method Not Allowed" },
  INTERNAL_SERVER_ERROR: { message: "Internal Server Error" },
  SERVICE_UNAVAILABLE: { message: "Account provisioning unavailable" },
});
export const accountProvisioningContract = {
  registerAccount: endpoint
    .input(
      z.object({
        query: z.strictObject({}).default({}),
        headers: z.object({ "idempotency-key": z.uuid().toLowerCase() }),
        body: passwordRegistrationSchema,
      }),
    )
    .meta(
      openapi({
        method: "POST",
        path: "/api/v2/accounts",
        inputStructure: "detailed",
        successStatus: 201,
      }),
    )
    .output(provisionedAccountSchema),
  provisionMyAccount: endpoint
    .input(
      z.object({
        query: z.strictObject({}).default({}),
        body: accountProfileSchema,
      }),
    )
    .meta(
      openapi({
        method: "PUT",
        path: "/api/v2/me/account",
        inputStructure: "detailed",
        spec: (spec) => ({ ...spec, security: [{ bearerAuth: [] }] }),
      }),
    )
    .output(provisionedAccountSchema),
};
